import React from 'react';
import { Wrench } from 'lucide-react';
import type { Project } from '../../../../../types/project';
import { BuckleArrestorSection } from './BuckleArrestorSection';
import { PipeInPipeSection } from './PipeInPipeSection';
import { BulkHeadSection } from './BulkHeadSection';
import { SpoolsSection } from './SpoolsSection';

interface FabricationTypeSectionProps {
  project: Project;
}

export const FabricationTypeSection: React.FC<FabricationTypeSectionProps> = ({ project }) => {
  // Check if fabrication is enabled at the top level
  if (!project.projectTypes.fabrication?.enabled) {
    return null;
  }

  const { options } = project.projectTypes.fabrication || {};

  return (
    <div className="space-y-6">
      <h4 className="text-md font-medium text-gray-700 flex items-center gap-2">
        <Wrench className="h-5 w-5" />
        Fabrication Options
      </h4>
      
      {/* Show fabrication sections only if they are selected */}
      {options?.buckleArrestor?.selected && (
        <BuckleArrestorSection project={project} />
      )}
      
      {options?.pipeInPipe?.selected && (
        <PipeInPipeSection project={project} />
      )}
      
      {options?.bulkhead?.selected && (
        <BulkHeadSection project={project} />
      )}

      {options?.spools?.selected && <SpoolsSection project={project} />}

      {/* Show message if no fabrication options are selected */}
      {(!options?.buckleArrestor?.selected &&
        !options?.pipeInPipe?.selected &&
        !options?.bulkhead?.selected &&
        !options?.spools?.selected) && (
        <div className="text-gray-500 text-sm italic">
          No fabrication options selected
        </div>
      )}
    </div>
  );
}; 